export let MediaFormat;
(function (MediaFormat) {
  MediaFormat["Avif"] = "avif";
  MediaFormat["Webp"] = "webp";
  MediaFormat["Jpeg"] = "jpeg";
  MediaFormat["Png"] = "png";
  MediaFormat["All"] = "all";
})(MediaFormat || (MediaFormat = {}));